import React, {useEffect, useMemo, useRef, useState} from 'react';
import ITypeUnite from "../../models/ITypeUnite";
import ListUniteDisponibleItem from "./list-unite-disponible-item";
import useApi from "../../hooks/useApi";
import {DateBox} from "devextreme-react/date-box";
import {Button} from "devextreme-react/button";
import IUnite from "../../models/IUnite";
import ILookupItem from "../../models/ILookupItem";
import Guid from "../../models/Guid";
import './liste-unite-produit-disponible.css';

interface IListUniteDisponibleProps {
    dateDebutReservation?: Date,
    dateFinReservation?: Date,
    isModeModify?: boolean
}

const ListUniteDisponible = ({dateDebutReservation, dateFinReservation, isModeModify}: IListUniteDisponibleProps) => {
    const {data: typeUnites, getData: getTypeUnite} = useApi<ITypeUnite[]>("typeunite")
    const [dateDebut, setDateDebut] = useState<Date>(dateDebutReservation || new Date())
    const [dateFin, setDateFin] = useState<Date>(dateFinReservation || new Date())
    const [forceRefresh, setForceRefresh] = useState(false)
    const [selectedUnite, setSelectedUnite] = useState<ILookupItem[]>()

    const typeUniteSorted = useMemo(() => typeUnites?.filter(type => !type.idTypeUnite?.equals([Guid.empty, Guid.max]) && type.actif).sort((typeUnite, typeUnite2) => {
        if (typeUnite.ordreAffichage !== typeUnite2.ordreAffichage) {
            return typeUnite.ordreAffichage < typeUnite2.ordreAffichage ? -1 : 1;
        }

        if (typeUnite.description !== typeUnite2.description) {
            return typeUnite.description < typeUnite2.description ? -1 : 1;
        }

        return 0;
    }), [typeUnites])

    useEffect(() => {
        getTypeUnite();
    }, [])

    useEffect(() => {
        if (dateDebut <= new Date(1900, 0, 1))
            setDateDebut(new Date());
        if (dateFin <= new Date(1900, 0, 1))
            setDateFin(new Date());

    }, [dateDebut, dateFin]);

    useEffect(() => {
        if (dateDebutReservation)
            setDateDebut(dateDebutReservation);
    }, [dateDebutReservation]);

    useEffect(() => {
        if (dateFinReservation)
            setDateFin(dateFinReservation)
    }, [dateFinReservation]);

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
            <div style={{display: "grid", padding: "0.5rem", gap: "0.5rem", gridTemplateColumns: "auto 1fr", alignItems: "center"}}>
                <div>Date d'arrivée :</div>
                <DateBox value={dateDebut} type={"datetime"} displayFormat={"dd-MM-yyyy HH:mm"} useMaskBehavior={true}
                         onValueChanged={(e) => setDateDebut(e.value)}/>
                <div>Date de départ :</div>
                <DateBox value={dateFin} type={"datetime"} displayFormat={"dd-MM-yyyy HH:mm"} useMaskBehavior={true}
                         onValueChanged={(e) => setDateFin(e.value)}/>
            </div>
            <div style={{margin: "0 1rem"}}>
                <Button type="default" icon="refresh" width={'100%'} text={'Rafraîchir'}
                        onClick={
                            () => {
                                setForceRefresh(prev => !prev)
                                setSelectedUnite([]);
                            }
                        }/>
            </div>
            <div id={"listeUniteDisponible"} style={{display: "flex", flexDirection: "column", gap: "0.2rem", padding: "1rem 0.5rem", overflowY: "auto", flex: "1 0"}}>
                {typeUniteSorted?.map((typeUnite) => {
                    return (
                        <ListUniteDisponibleItem
                            key={typeUnite?.idTypeUnite?.toString()}
                            typeUnite={typeUnite}
                            dateFin={dateFin}
                            dateDebut={dateDebut}
                            refresh={forceRefresh}
                            selectedUnite={selectedUnite || []}
                            setSelectedUnite={setSelectedUnite}
                            isModeModify={isModeModify}
                        />)
                })}
            </div>
        </div>
    );
}

export default ListUniteDisponible;
